import axios from "axios";
import { plainToInstance } from "class-transformer";
import { ResolveFastenEpicEndpointDto } from "healthex-common/fasten.epic.resolution.dtos";
import { FastenSearchResponseDto } from "healthex-common/fasten.search.dtos";
import { authenticatedApiConfig, generateURL } from "./BaseApiService";
export class PatientPortalSearchService {
    constructor(authenticationProvider, environment) {
        this.authenticationProvider = authenticationProvider;
        this.environment = environment;
    }
    async search(inputPayload) {
        const response = await axios.post(generateURL(this.environment.API_BASE_URL, "/fasten/search"), inputPayload, await authenticatedApiConfig(this.authenticationProvider));
        return plainToInstance(FastenSearchResponseDto, response.data);
    }
    async resolveEndpoint(input) {
        const response = await axios.post(generateURL(this.environment.API_BASE_URL, "/resolve-endpoint-info"), input, await authenticatedApiConfig(this.authenticationProvider));
        if (!response.data) {
            return null;
        }
        return plainToInstance(ResolveFastenEpicEndpointDto, response.data);
    }
}
